<template>
  <div style="padding-top: 80px; ">
    <TopNav activeIndex="5"></TopNav>
    <div class="about-header">
      <div class="about-header-container">
        <div class="about-herder-title">我们是谁？</div>
        <div class="about-header-text">
          <p>最懂编程的一群</p>
          <p>十多年一线互联网研发</p>
          <p>不忘初心、朝气蓬勃的团队</p>
          <p>把我们最会的编程，教给在人工智能时代成长的孩子们</p>
        </div>
      </div>
    </div>
    <div class="about">
      <div class="about-container">
        <div class="about-text-container">
          <div class="about-title">关于哆哆创客 /<span style="color: #999;font-size: 22px"> About Us</span> </div>
          <div class="about-line"></div>
          <div class="about-jieshao">
            <img src="../../../static/images/office/office1.png">
            <div class="about-jieshao-str">
              <p class="about-s-title">
                哆哆创客是广州哆哆科技有限公司旗下的STEAM教育品牌，总部位于广州，研发中心位于佛山广佛上城，是一家专注少儿编程，人工智能教育，致力于为3-16岁青少年提供专业的少儿编程培训机构。引进欧美先进教育理念和课程平台，在人工智能时代里，帮助中国青少年接轨世界最优秀的科学和编程教育，品牌的理念：让孩子们成为人工智能时代的领导者。
              </p>
              <p class="about-s-title">
                丰富完善的五大课程体系，采用线上互联网教学和线下校区教学模式。3-6岁孩子课程以机器人编程为主。7-12岁孩子采用国际最广泛使用的先进Scratch课程学习平台，12-16岁孩子以Python、JavaScript、C++课程为主。借助科学的教育理念、强大的师资力量、专业的系统研发能力，让中国青少年掌握人工智能时代必备编程技能，成为人工智能时代的领导者。
              </p>
              <p class="about-s-title">
                哆哆创客培养了一支富有事业心和责任心的专业师资队伍和一群技术强大的平台研发团队。致力于推动我国编程教育的普及和发展，为我国培养在人工智能领域的优秀人才。
              </p>
              <p class="about-s-title">
                目前广州有线下直营校区、多家合作分校，并逐步走进幼儿园、学校开展兴趣班。哆哆创客与广东省社区少年宫强强联合，将哆哆创客课程体系融入到少年宫中。
              </p>
            </div>
            <div class="about-item-container">
              <div class="about-item-img">
                <img src="../../../static/images/office/office3.png">
              </div>
              <div class="about-item-img">
                <img src="../../../static/images/office/office2.png">
              </div>
              <div class="about-item-img">
                <img src="../../../static/images/office/office4.png">
              </div>
              <div class="about-item-img">
                <img src="../../../static/images/office/office5.png">
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <div class="honor">
      <div class="honor-container">
        <div class="honor-text-container">
          <div class="honor-title">企业荣誉 /<span style="color: #999;font-size: 22px"> Our Honor</span> </div>
          <div class="honor-line"></div>
          <div class="honor-jieshao">
            <div class="honor-item-container">
              <div class="honor-item-img">
                <img src="../../../static/images/honor/1.png">
                <p>
                  中国电子协会
                </p>
                <p>
                  会员单位
                </p>
              </div>
              <div class="honor-item-img">
                <img src="../../../static/images/honor/2.png">
                <p>
                  中国青少年科技辅导员协会
                </p>
                <p>
                  会员单位
                </p>
              </div>
              <div class="honor-item-img">
                <img src="../../../static/images/honor/3.png">
                <p>
                  哆哆创客少儿编程
                </p>
                <p>
                  培训基地
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import TopNav from '@/components/top/TopNav'
import Footer from '@/components/bottom/Footer'

export default {
  components: {
    TopNav,
    Footer
  },
  data () {
    return {}
  },
  mounted () {

  },
  props: {},
  methods: {

  }
}

</script>
<style>
  @import url('./about.css');

</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue